import { Dropdown, DropdownButton } from "@similarweb/ui-components";

import type { IModifiablePrompt } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/prompts-report/edit-modal/types";

import { StyledDropdownItem, TopicsDropdownWrapper } from "./PromptsTable.styled";

interface ITopicsDropdownProps {
    prompt: IModifiablePrompt;
    allTopics: string[];
    onEdit: (prompt: IModifiablePrompt, topic: string) => void;
}

export const TopicsDropdown = ({ prompt, allTopics, onEdit }: ITopicsDropdownProps) => {
    const selectedTopic = prompt?.currentTopicName ?? "";

    return (
        <TopicsDropdownWrapper>
            <Dropdown
                appendTo="body"
                cssClassContainer="DropdownContent-container FiltersBarDropdown"
                onClick={({ id: topic }) => onEdit(prompt, topic as string)}
                selectedIds={{ [selectedTopic]: true }}
                closeOnItemClick
                buttonWidth="100%"
                width={200}
            >
                {[
                    <DropdownButton
                        key={`current-${selectedTopic}`}
                        cssClass="DropdownButton--filtersBarDropdownButton"
                    >
                        {selectedTopic}
                    </DropdownButton>,
                    ...allTopics.map((topic: string) => (
                        <StyledDropdownItem
                            key={topic}
                            id={topic}
                        >
                            {topic}
                        </StyledDropdownItem>
                    )),
                ]}
            </Dropdown>
        </TopicsDropdownWrapper>
    );
};
